import { render, staticRenderFns } from "./PromptListPage.vue?vue&type=template&id=4f7d7a28&scoped=true&"
import script from "./PromptListPage.vue?vue&type=script&lang=js&"
export * from "./PromptListPage.vue?vue&type=script&lang=js&"
import style0 from "./PromptListPage.vue?vue&type=style&index=0&id=4f7d7a28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7d7a28",
  null
  
)

export default component.exports